import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';


@Injectable({
    providedIn: 'root'
})
export class SentenceService { 
    url='keywords/sentence';
    constructor(private http:HttpClient) {}

   
  
    get(keyword:any,from:any,to:any){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}?word=${keyword}&from=${from}&to=${to}`);
    }

    
}